<template>
    <section style="margin: 18px;">
        <v-data-table :headers="headers" hide-actions
                      disable-initial-sort :items="GetWebinarRegistrations" item-key="_id" class="elevation-1" style="margin-bottom: 18px;">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
                </tr>
            </template>
            <template v-slot:items="props">
            <tr>
                <td class="text-xs-center">{{ props.item.Webinar_Title }}</td>
                <td class="text-xs-center">{{ props.item.Name }}</td>
                <td class="text-xs-center">{{ props.item.Email }}</td>
                <td class="text-xs-center">{{ props.item.Phone_Number }}</td>
            </tr>
            </template>
      </v-data-table>
      <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
    </section>
</template>
<script>
export default {
    data(){
        return {
            headers : [
                        { text: "Webinar Title", value: "Webinar_Title" },
                        { text: "Name", value: "Name" },
                        { text: "Email", value: "Email" },
                        { text: "Phone Number", value: "Phone_Number" },
                      ],
            pages                       : 1,
            records                     : 0,
        }
    },
    computed:{
        GetWebinarRegistrations(){
            return this.$store.getters.GetWebinarRegisterList
        }
    },
    methods:{
        GetNextSetOfData(){

            let data = { limit:10, page : this.pages }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/webinar/findregisterwebinar`,data)
                        .then(response =>{
                                
                                this.records = response['data']['Records'] ? response['data']['Records'] : 0
                                this.$store.commit('SetWebinarRegisterList',response['data']['response'])
                                this.$eventHub.$emit("LOADING",'false')
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Webinar","Color":"red","Close": false });
                        })
        }
    },
    mounted(){
        this.GetNextSetOfData()
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
</style>